function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { T } from 'shared/helper/translate';
import { STATUSES } from 'researcher/plagiarism/constants';
import { NUMBER_OF_SECONDS_BETWEEN_DOCUMENT_CREATION_DATE_TEXT_UPDATES } from '../../constants';
var RubriqPlagiarismDocumentCardStatus = function RubriqPlagiarismDocumentCardStatus(_ref) {
  var document = _ref.document;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    creationDateText = _useState2[0],
    setCreationDateText = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isExpiring = _useState4[0],
    setIsExpiring = _useState4[1];
  var intervalRef = useRef(null);
  var isReduxProcessing = useSelector(function (state) {
    var _state$plagiarism;
    return ((_state$plagiarism = state.plagiarism) === null || _state$plagiarism === void 0 || (_state$plagiarism = _state$plagiarism.processingDocuments) === null || _state$plagiarism === void 0 ? void 0 : _state$plagiarism[document.fileIdentity]) || false;
  });
  var generate = document.status === STATUSES.STATUS_GENERATE;
  var processing = document.status === STATUSES.STATUS_PROCESSING || isReduxProcessing;
  var generated = document.status === STATUSES.STATUS_GENERATED;
  var failed = document.status === STATUSES.STATUS_FAILED;
  var initialized = document.status === STATUSES.STATUS_INITIALIZED;
  var formatDocumentAge = function formatDocumentAge(dateString) {
    var createdDate = moment.utc(dateString, 'YYYY-MM-DD HH:mm:ss.SSSSSS');
    var now = moment.utc();
    if (!createdDate.isValid()) {
      return {
        text: 'Invalid date',
        isExpiring: false
      };
    }
    var duration = moment.duration(now.diff(createdDate));
    var minutes = Math.floor(duration.asMinutes());
    if (minutes < 0) {
      console.warn('Negative duration detected:', {
        created: createdDate.format(),
        now: now.format(),
        diffMinutes: minutes
      });
      return {
        text: 'Uploaded just now',
        isExpiring: false
      };
    }
    var days = Math.floor(duration.asDays());
    var hours = Math.floor(duration.asHours());
    if (days === 0) {
      if (hours === 0) {
        if (minutes < 1) {
          return {
            text: 'Uploaded just now',
            isExpiring: false
          };
        }
        return {
          text: "Uploaded ".concat(minutes, " minute").concat(minutes === 1 ? '' : 's', " ago"),
          isExpiring: false
        };
      }
      return {
        text: "Uploaded ".concat(hours, " hour").concat(hours === 1 ? '' : 's', " ago"),
        isExpiring: false
      };
    }
    if (document.status === STATUSES.STATUS_INITIALIZED) {
      if (days > 30) {
        return {
          text: 'Expired',
          isExpiring: true
        };
      }
      if (days >= 20) {
        var daysRemaining = 30 - days;
        if (daysRemaining === 0) {
          return {
            text: 'Expiring today',
            isExpiring: true
          };
        }
        return {
          text: "Expiring in ".concat(daysRemaining, " day").concat(daysRemaining === 1 ? '' : 's'),
          isExpiring: true
        };
      }
    }
    return {
      text: "Uploaded ".concat(days, " day").concat(days === 1 ? '' : 's', " ago"),
      isExpiring: false
    };
  };
  useEffect(function () {
    var _document$createdAt;
    var creationDate = (_document$createdAt = document.createdAt) === null || _document$createdAt === void 0 ? void 0 : _document$createdAt.date;
    var _formatDocumentAge = formatDocumentAge(creationDate),
      text = _formatDocumentAge.text,
      isExpiring = _formatDocumentAge.isExpiring;
    setCreationDateText(text);
    setIsExpiring(isExpiring);
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    intervalRef.current = setInterval(function () {
      var _document$createdAt2;
      var _formatDocumentAge2 = formatDocumentAge((_document$createdAt2 = document.createdAt) === null || _document$createdAt2 === void 0 ? void 0 : _document$createdAt2.date),
        text = _formatDocumentAge2.text,
        isExpiring = _formatDocumentAge2.isExpiring;
      setCreationDateText(text);
      setIsExpiring(isExpiring);
    }, NUMBER_OF_SECONDS_BETWEEN_DOCUMENT_CREATION_DATE_TEXT_UPDATES * 1000);
    return function () {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [document.createdAt, document.status]);
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 align-items-center rubriq-text-document-status"
  }, function () {
    if (processing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "d-flex gap-2 align-items-center"
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: "fa-light fa-arrows-rotate-reverse"
      }), /*#__PURE__*/React.createElement(T, {
        source: "Processing",
        spin: true
      }));
    }
    if (generated) {
      return /*#__PURE__*/React.createElement("div", {
        className: "d-flex gap-2 align-items-center"
      }, /*#__PURE__*/React.createElement(T, {
        source: "report_generated"
      }));
    }
    if (failed) {
      return /*#__PURE__*/React.createElement("div", {
        className: "d-flex gap-2 align-items-center"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-danger"
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: "fa-light fa-triangle-exclamation"
      }), ' ', /*#__PURE__*/React.createElement(T, {
        source: "processing_failed"
      })));
    }
    if (generate) {
      return /*#__PURE__*/React.createElement("div", {
        className: "d-flex gap-2 align-items-center"
      }, /*#__PURE__*/React.createElement(T, {
        source: "access_granted"
      }));
    }
    return null;
  }(), /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 align-items-center"
  }, generate || processing || generated || failed ? /*#__PURE__*/React.createElement(React.Fragment, null, "\xB7") : '', initialized ? /*#__PURE__*/React.createElement("span", {
    style: {
      color: isExpiring ? '#ab6401' : '#4C5763'
    }
  }, creationDateText, "\xA0") : /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#4C5763'
    }
  }, creationDateText, "\xA0")));
};
export default RubriqPlagiarismDocumentCardStatus;